import DataSource from "./datasource";
import AjaxDataSourceService from "./datasource-ajax";
import FetchDataSourceService  from "./datasource-fetch";
import JsonpDataSourceService from "./datasource-jsonp";
import { TagSelector } from "./tagselector";

function createTagSelectorUI(container: HTMLElement): void {

    const tagSelectorContainer = document.createElement('div')
    tagSelectorContainer.style.height = '22px'
    tagSelectorContainer.style.width = '280px'
    container.appendChild(tagSelectorContainer)

    const serverReadService: string = "list"

    const tagSelector = new TagSelector({
        dataTextField: 'ProductName',
        dataValueField: 'ProductID',
        serverReadService: serverReadService,
        minLengthFilter: 0,
        liveFilter: true,
        maxItems: 3,
        dataSource: new DataSource({
            serverFiltering: false,
            serverFilteringService: serverReadService,
            services: [
                new JsonpDataSourceService(serverReadService, "https://demos.telerik.com/kendo-ui/service/products")
            ]
        })
    })
    tagSelector.render(tagSelectorContainer)
}
createTagSelectorUI(document.body)

export { DataSource, AjaxDataSourceService, JsonpDataSourceService , FetchDataSourceService}



